/**
 * Configuration items — the CMDB.
 *
 * There is no CI-listing endpoint yet, and this screen says so rather than rendering an empty
 * table. An empty table is indistinguishable from "you have no assets", which for a CMDB is the
 * most alarming thing it could tell you and would be a lie.
 */

import type { JSX } from 'react';

import { Card, Empty, PageHeader } from '../shared/ui/ui';

export function ConfigurationItems(): JSX.Element {
  return (
    <>
      <PageHeader
        title="Configuration items"
        subtitle="The CMDB. Everything else reads from it — access scope, risk ranking, playbook matching, and ticket routing."
      />

      <Card title="Not built yet">
        <Empty>
          Configuration items exist in the database with their access ceiling, criticality, and
          owner group, and both the capture and vulnerability screens resolve against them. There
          is no read endpoint to list them yet, so this screen is deliberately empty rather than
          showing a table that would read as &ldquo;no assets&rdquo;.
        </Empty>
      </Card>

      <Card
        title="What lands here"
        subtitle="From docs/DESIGN.md §2.1 — the CMDB is the hub, not an inventory kept beside the platform."
      >
        <ul className="findings">
          <li>The typed access ceiling: what any session may ever do to this asset.</li>
          <li>Criticality and owner group, which drive risk ranking and campaign assignment.</li>
          <li>Internet exposure, which multiplies the risk of every finding on the asset.</li>
          <li>Its captured configuration and telemetry, bracketing the work on each ticket.</li>
        </ul>
      </Card>
    </>
  );
}
